export default "__VITE_ASSET__CXZjAmt1__"